import { render, staticRenderFns } from "./NextAppearance.vue?vue&type=template&id=44580a88"
import script from "./NextAppearance.vue?vue&type=script&lang=ts"
export * from "./NextAppearance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports